import { z } from 'zod';

export const recordWebVisitorV2BodySchema = z.object({
  attributionPayload: z.string().nullable(),
  fingerprint: z.string().min(1).max(512),
  handoffToken: z.string().min(1).optional(),
  visitorId: z.string().min(1).max(128),
});

export type IRecordWebVisitorV2Body = z.infer<typeof recordWebVisitorV2BodySchema>;
